import Expand from "./expand.svg";

export default Expand;
